export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";